module.exports = __webpack_public_path__ + "static/media/lenderWhite.0dba1a67.svg";